<template>
  <tr class="invoice">
    <td class="invoice_number">{{ invoice.invoiceNumber }}</td>
    <td class="invoice_date">{{ invoice.date | dateFormat }}</td>
    <td class="invoice_type">{{ invoice.invoiceType | invoiceSpecificationType }}</td>
    <td class="invoice_amount">{{ invoice.totalAmount | currency }}</td>
    <td class="invoice_pdf">
      <a v-for="(invoiceDocument, index) in getAvailableSpecificationDocuments()"
         :class="invoiceDocument.fileType | invoiceDocumentTypeIconClass"
         :key="index"
         :title="'Exporteren naar een '+invoiceDocument.fileType.toUpperCase()+' bestand'"
         @click="downloadInvoiceDocument(invoice, invoiceDocument.role, invoiceDocument.fileType)"
      >{{ invoiceDocument.fileType.toUpperCase() }}</a>
    </td>
  </tr>
</template>

<script>

import customFilters from '../../filters'
import invoiceDocumentGroupListItem from '../../mixins/invoice-document-group-list-item'

export default {
  name: 'InvoiceSpecificationsListItem',
  mixins: [invoiceDocumentGroupListItem],
  data () {
    return {
      filters: {
        dateFormat: customFilters.dateFormat,
        invoiceSpecificationType: customFilters.invoiceSpecificationType,
        currency: customFilters.currency,
        invoiceDocumentTypeIconClass: customFilters.invoiceDocumentTypeIconClass
      }
    }
  },
  methods: {
    getAvailableSpecificationDocuments () {
      return this.invoice.invoiceDocuments.filter(invoiceDocument => {
        return invoiceDocument.isAvailable && invoiceDocument.role === 'INVOICE_SPECIFICATION'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoiceSpecifications/InvoiceSpecificationsListItem.vue